module.exports = __webpack_public_path__ + "assets/images/render-txt-detaility.dcfa330236f589fd385d692c450fac48.svg";